// 홈스쿨링 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import ReactEcharts from "echarts-for-react";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";
import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";

import flyengStyle from "../../components/style";

import CardStatContent, { CardStatBranchContent } from "../../components/CardStatContent";

const BranchStatCategory = ({ libCategories, statBranch, selectedSubOption }) => {
    const countField = selectedSubOption === "content" ? "playCount" : "playCountSum";
    const defaultColDef = {
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 60,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };

    const listColumn = [
        {
            headerName: "",
            field: "branchName",
            minWidth: 150,
            maxWidth: 150,
            pinned: "left",
        },
        {
            headerName: "TOTAL",
            field: countField,
            pinned: "left",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    if (libCategories) {
        libCategories.forEach((c) => {
            const fieldId = `playCountCat_${c.id}`;
            listColumn.push({
                headerName: c.name,
                field: fieldId,
                minWidth: 70,
                cellRenderer: (param) => {
                    return param.value ? param.value.toLocaleString() : "-";
                },
            });
        });
    }

    return <AgGridReactEx height={500} defaultColDef={defaultColDef} columnDefs={listColumn} rowData={statBranch} />;
};
const BranchContent = forwardRef(({ branchList, libCategories, statPeriod, selectedSubOption = "content", updateViewSubOption, onViewSubOptionSelected }, ref) => {
    const [subOptionApplied, setSubOptionApplied] = useState(false);
    const [statAll, setStatAll] = useState(false);
    const [statBranch, setStatBranch] = useState(false);
    const [branchCount, setBranchCount] = useState(0); // 테스트 지사가 아닌 지사 개수
    const [totalCount, setTotalCount] = useState(false);

    const countField = selectedSubOption === "content" ? "playCount" : "playCountSum";

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: `플라잉홈_지사콘텐츠(${selectedSubOption === "content" ? "순" : "누적"})통계`,
                sheets: [
                    {
                        name: "콘텐츠",
                        title: `홈스쿨링 지사콘텐츠(${selectedSubOption === "content" ? "순" : "누적"}) 통계`,
                        columnTitle: ["지사", "전체", `클래스(${selectedSubOption === "content" ? "순" : "누적"}) 실행 수`].concat(libCategories.map((lc) => lc.name)),
                        data: statBranch ? statBranch.map((s) => [s.branchName, s[countField], s.totalClass].concat(libCategories.map((lc) => s[`playCountCat_${lc.id}`]))) : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = () => {
        setStatBranch(false);
        if (selectedSubOption != "-") {
            axios({
                method: "POST",
                url: `/api/flyeng_stat_2022/home/branch/content`,
                data: {
                    startDate: statPeriod.startDate,
                    endDate: statPeriod.endDate,
                    periodType: statPeriod.type,
                    type: selectedSubOption,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        const statClass = result.data.data.classBranchContent;
                        const statHome = result.data.data.homeBranchContent;
                        const statBranch = [];
                        let totalCount = 0;
                        const branchCount = branchList.reduce((ac, current) => ac + (current.type == "B" ? 1 : 0), 0);

                        if (statHome && statHome.length > 0) {
                            const statCategoryBase = {};
                            libCategories.forEach((lc) => (statCategoryBase[`playCountCat_${lc.id}`] = 0));
                            branchList.forEach((b) => {
                                const newBranch = { branchId: b.id, branchName: b.name, total: 0, ...statCategoryBase };

                                if (statHome && statHome.length > 0) {
                                    const stats = statHome.filter((s) => s.branchId == b.id);
                                    newBranch[countField] = 0;
                                    stats.forEach((s) => {
                                        newBranch[`playCountCat_${s.categoryId}`] = s[countField];
                                        newBranch[countField] += s[countField];
                                    });
                                }

                                if (newBranch[countField] > 0) {
                                    statBranch.push(newBranch);
                                    totalCount += newBranch[countField];
                                }
                            });

                            statBranch.sort((a, b) => b[countField] - a[countField]);

                            if (statClass && statClass.length > 0) {
                                statClass.forEach((s) => {
                                    const branch = statBranch.find((c) => c.branchId === s.branchId);
                                    if (branch) {
                                        branch.totalClass = s.total;
                                    }
                                });
                            }
                        }

                        setStatAll(statHome);
                        setStatBranch(statBranch);
                        setBranchCount(branchCount);
                        setTotalCount(totalCount);
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };
    useEffect(() => {
        if (!subOptionApplied && updateViewSubOption) {
            updateViewSubOption(
                [
                    { name: "콘텐츠 순 실행 수", id: "content" },
                    { name: "콘텐츠 누적 실행 수", id: "sum" },
                ],
                "content"
            );
            setSubOptionApplied(true);
        }
        return () => {};
    }, [subOptionApplied]);
    useEffect(() => {
        if (subOptionApplied) {
            getStat();
        }
        return () => {};
    }, [statPeriod, selectedSubOption]);
    const chartOption = {
        grid: {
            top: "10%",
            left: "5%",
            right: "5%",
            bottom: "15%",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "cross",
                crossStyle: {
                    color: "#999",
                },
            },
        },
        legend: {
            data: [`홈스쿨링 ${selectedSubOption === "content" ? "순" : "누적"} 실행 수`, `클래스 ${selectedSubOption === "content" ? "순" : "누적"} 실행 수`],
        },
        xAxis: [
            {
                type: "category",
                data: statBranch ? statBranch.map((d) => d.branchName) : [],
                axisPointer: {
                    type: "shadow",
                },
                axisLabel: {
                    show: true,
                    interval: 0,
                    rotate: 45,
                },
            },
        ],
        yAxis: [
            {
                type: "value",
                name: `홈스쿨링 ${selectedSubOption === "content" ? "순" : "누적"} 실행 수`,
                min: 0,
                axisLabel: {
                    formatter: (value) => {
                        return value.toLocaleString();
                    },
                },
            },
            {
                type: "value",
                name: `클래스 ${selectedSubOption === "content" ? "순" : "누적"} 실행 수`,
                min: 0,
                axisLabel: {
                    formatter: (value) => {
                        return value.toLocaleString();
                    },
                },
            },
        ],
        series: [
            {
                name: `홈스쿨링 ${selectedSubOption === "content" ? "순" : "누적"} 실행 수`,
                type: "bar",
                tooltip: {
                    valueFormatter: function (value) {
                        return value ? value.toLocaleString() : value;
                    },
                },
                color: flyengStyle.seriesHomeColor2022.normal,
                data: statBranch ? statBranch.map((d) => (selectedSubOption === "content" ? d.playCount : d.playCountSum)) : [],
            },
            {
                name: `클래스 ${selectedSubOption === "content" ? "순" : "누적"} 실행 수`,
                type: "line",
                yAxisIndex: 1,
                tooltip: {
                    valueFormatter: function (value) {
                        return value ? value.toLocaleString() : value;
                    },
                },
                color: "#d87a80",
                data: statBranch ? statBranch.map((d) => (selectedSubOption === "content" ? d.totalClass : d.totalClass)) : [],
            },
        ],
    };
    const typeTitle = selectedSubOption === "content" ? "순" : "누적";
    const branchTop = statBranch && statBranch.length > 0 ? statBranch[0] : null;
    const branchLast = statBranch && statBranch.length > 0 ? statBranch[statBranch.length - 1] : null;
    const avgTotal = (totalCount / branchCount).toFixed(1);

    return (
        <div className="stat-branch-content">
            <div className="row mb-2">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                    <CardStatContent
                        id="1"
                        title={`전체 콘텐츠 ${typeTitle} 실행 수`}
                        titleTotal="합계"
                        total={totalCount.toLocaleString()}
                        average={avgTotal.toLocaleString()}
                        titleBgClass="bg-tomonote"
                    />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                    <CardStatBranchContent id="4" top={branchTop} last={branchLast} />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="card">
                        <div className="card-body" style={{ height: "500px", textAlign: "center" }}>
                            <ReactEcharts
                                theme="macarons"
                                style={{
                                    height: "100%",
                                    width: "100%",
                                }}
                                option={chartOption}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="card">
                        <div className="card-body" style={{ height: `540px` }}>
                            <BranchStatCategory libCategories={libCategories} selectedSubOption={selectedSubOption} statBranch={statBranch} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default BranchContent;
